<template>
  <div id="listPage">
    <el-table
      v-if="isShowTable"
      :inline="true"
      :data="tableData"
      size="mini"
      :cell-style="toggleDisplayTr"
      row-key="id"
      v-loading="loadings.loading"
      border
      stripe
      :max-height="tableHeight"
      class="tables"
    >
      <el-table-column
        show-overflow-tooltip
        label="内容分类"
        :min-width="6 * 35"
      >
        <template slot-scope="scope">
          <p
            :style="`margin-left: ${
              scope.row.Levels * 10
            }px;margin-top:0;margin-bottom:0;
    display: flex;
    align-items: center;`"
          >
            <i
              v-if="
                scope.row.ItemTypeCode != 'label' &&
                scope.row.trueFalse != '1' &&
                AllowEdit == 1 &&
                scope.row.Memo41 != '1'
              "
              class="el-icon-circle-plus-outline"
              aria-hidden="true"
              style="font-size: 14px; margin-left: -10px; margin-right: 10px"
              tree-icon-collapse
              @click="addDetailsClick(scope)"
            ></i>
            <i
              v-if="scope.row.Memo1True && scope.row.Memo41 == '1'"
              class="el-icon-remove-outline"
              aria-hidden="true"
              style="
                font-size: 14px;
                margin-left: -10px;
                margin-right: 10px;
                color: red;
              "
              tree-icon-collapse
              @click="delDetailsClick(scope)"
            ></i>
            <i
              style="font-size: 14px"
              tree-icon-collapse
              @click="toggleFoldingStatus(scope.row)"
              :class="toggleFoldingClass(scope.row)"
              aria-hidden="true"
            ></i>
            <span style="word-break: break-all; white-space: normal">
              {{ scope.row.ItemLabel }}
            </span>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="问题类别"
        :min-width="4 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <textarea
            v-if="!scope.row.Memo1True"
            :disabled="!scope.row.Memo1True"
            v-model.lazy="scope.row.Memo1"
            class="el-textarea__inner"
            :class="{
              isdisabled: !scope.row.Memo1True,
            }"
            :ref="'tableColumn' + scope.$index + 0" 
          />
          <div v-else>
            <el-select
              clearable
              v-model="scope.row.Memo1"
              v-if="scope.row.Memo1Code && scope.row.Memo1Type == 'select'"
              @change="Memo1Chenge(scope.row)"
              :disabled="!scope.row.Memo1True"
              :ref="'tableColumn' + scope.$index + 0" 
            >
              <el-option
                v-for="item in scope.row.Memo1Code.split(',')"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- <el-input
            v-else
            v-model="tableData[scope.$index].Memo1"
            :disabled="!scope.row.Memo1True"
            type="text"
            ></el-input> -->
            <div class="el-input--mini" v-else>
              <input
                :disabled="!scope.row.Memo1True"
                v-model.lazy="scope.row.Memo1"
                class="el-input__inner"
                :class="{
                  isdisabled: !scope.row.Memo1True,
                }"
                :ref="'tableColumn' + scope.$index + 0" 
              />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="PerType"
        label="其他问题类别 （如选择“其他”请描述）"
        min-width="188px"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1 ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo2True
            "
            v-model="tableData[scope.$index].Memo2"
            type="textarea"
          ></el-input>-->
          <div class="el-textarea">
            <textarea
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo2True
              "
              v-model.lazy="scope.row.Memo2"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo2True,
              }"
              :ref="'tableColumn' + scope.$index + 1" 
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="严重程度分级"
        :min-width="3 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <div v-if="scope.row.DataSrcCode != ''">
            <el-select
              placeholder
              clearable
              v-model="scope.row.Memo3"
              v-if="scope.row.Memo3Type == 'select'"
              @change="forceUpdateChange(scope)"
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo3True
              "
              :ref="'tableColumn' + scope.$index + 2" 
            >
              <el-option
                v-for="item in scope.row.Memo3Code.split(',')"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>

          <!-- <el-input
            v-else
            v-model="tableData[scope.$index].Memo3"
            :disabled="
            scope.row.Memo1.indexOf('NA') != -1  ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo3True
            "
            type="text"
          ></el-input>-->

          <div class="el-input--mini" v-else>
            <input
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo3True
              "
              v-model.lazy="scope.row.Memo3"
              type="text"
              class="el-input__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo3True,
              }"
              :ref="'tableColumn' + scope.$index + 2" 
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="CPath"
        label=" 问题描述"
        min-width="188px"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
            scope.row.Memo1.indexOf('NA') != -1  ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo4True
            "
            v-model="tableData[scope.$index].Memo4"
            type="textarea"
          ></el-input>-->

          <div class="el-textarea">
            <textarea
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo4True
              "
              v-model.lazy="scope.row.Memo4"
              type="textarea"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo4True,
              }"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="IsValid"
        label="参考依据"
        min-width="188px"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1  ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo5True
            "
            v-model="tableData[scope.$index].Memo5"
            type="textarea"
          ></el-input>-->

          <div class="el-textarea">
            <textarea
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo5True
              "
              v-model.lazy="scope.row.Memo5"
              type="textarea"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo5True,
              }"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="AddTime"
        label="纠正和预防措施"
        :min-width="5 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1 ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo6True
            "
            v-model="tableData[scope.$index].Memo6"
            type="text"
          ></el-input>-->

          <div class="el-textarea">
            <textarea
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo6True
              "
              v-model.lazy="scope.row.Memo6"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo6True,
              }"
              :ref="'tableColumn' + scope.$index + 4" 
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="IsValid"
        label="责任人"
        width="92px"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1 ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo11True
            "
            v-model="tableData[scope.$index].Memo11"
            type="text"
          ></el-input>-->

          <div class="el-input--mini">
            <input
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo11True
              "
              v-model.lazy="scope.row.Memo11"
              type="text"
              class="el-input__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo11True,
              }"
              :ref="'tableColumn' + scope.$index + 5" 
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="EditTime"
        label="计划完成日期"
        :min-width="4 * 35"
        width="125px"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <el-date-picker
            :disabled="
              scope.row.Memo1.indexOf('NA') != -1 ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              scope.row.Memo1 == '优' ||
              !scope.row.Memo7True
            "
            v-model="scope.row.Memo7"
            value-format="yyyy-MM-dd"
            type="date"
            class="dates"
            placeholder="选择日期"
            :ref="'tableColumn' + scope.$index + 6" 
          ></el-date-picker
          ><!-- :picker-options="pickerOptions0" -->
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="EditTime"
        label="实际完成日期"
        width="125px"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <el-date-picker
            :disabled="
              scope.row.Memo1.indexOf('NA') != -1 ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              scope.row.Memo1 == '优' ||
              !scope.row.Memo8True
            "
            v-model="scope.row.Memo8"
            value-format="yyyy-MM-dd"
            type="date"
            class="dates"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            :ref="'tableColumn' + scope.$index + 7" 
          ></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="EditTime"
        label="文件资料支持（如需）"
        :min-width="4 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <div style="display: flex; justify-content: space-between">
            <el-upload
              v-if="
                scope.row.Memo1.indexOf('NA') == -1 &&
                scope.row.Memo1 != '未查' &&
                scope.row.Memo1 != '未发现问题' &&
                scope.row.Memo1 != '优' &&
                scope.row.Memo9True
              "
              class="upload-comps"
              :action="hostUrl + '/api/File/UploadSync'"
              :show-file-list="false"
              :on-progress="importProgress"
              :before-upload="beforeUpload"
              :on-error="importError"
              :multiple="true"
              :file-list="fileList"
              :on-success="
                function (response) {
                  return importSuccess(response, scope);
                }
              "
            >
              <el-button
                :loading="uploading"
                size="mini"
                type="primary"
                @click="scope.row.downloadVisibss = false"
                >上传</el-button
              >
            </el-upload>
              <el-popover
              :ref="scope.row.Id"
              placement="bottom-start"
              width="150"
              trigger="hover"
            >
            <!-- trigger="hover" -->

              <el-row type="flex" >
                <el-col :span="12">
                  <el-button
                    class="upload_comps"
                    v-for="(item, index) in Array.isArray(scope.row.Memo9)
                      ? scope.row.Memo9
                      : scope.row.Memo9.split(',').filter(element => element.trim() !== '')"
                    v-show="shouldShowButton(scope.row.Memo9)"
                    :key="index"
                    size="mini"
                    type="success"
                    @click="openWPlural(item)"
                    >下载{{ index + 1 }}</el-button
                  >
                </el-col>
                <el-col :span="12">
                  <el-button
                    class="upload_comps"
                    v-for="(item, index) in Array.isArray(scope.row.Memo9)
                      ? scope.row.Memo9
                      : scope.row.Memo9.split(',').filter(element => element.trim() !== '')"
                    v-show="shouldShowButton(scope.row.Memo9)"
                    :key="index"
                    size="mini"
                    type="danger"
                    @click="openWdelete(scope.row, item)"
                    >删除{{ index + 1 }}</el-button
                  >
                </el-col>
              </el-row>
            </el-popover>
              <el-button
              v-popover="scope.row.Id"
              v-show="shouldShowButton(scope.row.Memo9)"
              size="mini"
              type="success"
              @click="openW(scope.row)"
              >下载</el-button
            >
            <!-- <el-button 
              v-show="shouldShowButton(scope.row.Memo9)"
              size="mini"
              type="danger"
              @click="materialdelete(scope.row)"
              >删除</el-button
            > -->
            <!-- <el-button
              v-if="scope.row.Memo9"
              v-for="(item,index) in scope.row.Memo9.split(',')"
              size="mini"
              :key="item"
              type="success"
              @click="openW(item)"
              >下载{{ index+1 }}</el-button
            > -->
            <!-- <el-button v-if="scope.row.Memo9" @click="">删除</el-button> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="EditTime"
        label="备注（无需整改或未能整改的在此说明）"
        :min-width="4 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1  ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo10True
            "
            v-model="tableData[scope.$index].Memo10"
            type="text"
          ></el-input>-->

          <div class="el-textarea--mini">
            <textarea
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo10True
              "
              v-model.lazy="scope.row.Memo10"
              type="text"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo10True,
              }"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="PM审核"
        :min-width="4 * 35"
        :filtered-value="filterValue"
        :filters="[
          { text: '同意', value: '1' },
          { text: '拒绝', value: '2' },
          { text: '待审核', value: '0' },
        ]"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <div style="display: flex; justify-content: space-between">
            <el-radio-group
              v-model="scope.row.Memo12"
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo12True
              "
            >
              <el-radio label="1">同意</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="审核意见"
        :min-width="4 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1  ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo13True
              
            "
            v-model="tableData[scope.$index].Memo13"
            type="text"
          ></el-input>-->

          <div class="el-textarea--mini">
            <textarea
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo13True
              "
              v-model.lazy="scope.row.Memo13"
              type="text"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo13True,
              }"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        label="负责人审核"
        :min-width="4 * 35"
        :filtered-value="directorFilterValue"
        :filters="[
          { text: '同意', value: '1' },
          { text: '拒绝', value: '2' },
          { text: '待审核', value: '0' },
        ]"
        :filter-method="directorFilterHandler"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <div style="display: flex; justify-content: space-between">
            <el-radio-group
              v-model="scope.row.Memo14"
              :disabled="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo14True
              "
            >
              <el-radio label="1">同意</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="负责人审核意见"
        :min-width="4 * 35"
      >
        <template slot-scope="scope" v-if="scope.row.ItemTypeCode != 'label'">
          <!-- <el-input
            :disabled="
             scope.row.Memo1.indexOf('NA') != -1 ||
              scope.row.Memo1 == '未查' ||
              scope.row.Memo1 == '未发现问题' ||
              !scope.row.Memo15True
            "
            v-model="tableData[scope.$index].Memo15"
            type="text"
          ></el-input>-->

          <div class="el-textarea--mini">
            <textarea
              :readonly="
                scope.row.Memo1.indexOf('NA') != -1 ||
                scope.row.Memo1 == '未查' ||
                scope.row.Memo1 == '未发现问题' ||
                scope.row.Memo1 == '优' ||
                !scope.row.Memo15True
              "
              v-model.lazy="scope.row.Memo15"
              type="text"
              class="el-textarea__inner"
              :class="{
                isdisabled:
                  scope.row.Memo1.indexOf('NA') != -1 ||
                  scope.row.Memo1 == '未查' ||
                  scope.row.Memo1 == '未发现问题' ||
                  scope.row.Memo1 == '优' ||
                  !scope.row.Memo15True,
              }"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import store from "./../../utils/storage";

import { getBaseUrl } from "../../api/api";
import uuidv4 from "uuid/v4";
export default {
  name: "ProjectInfo",
  props: ["tableData", "AllowEdit", "isDefaultRefuse"],
  data: () => ({
    pickerOptions0: {
      disabledDate(time) {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
    pickerOptions1: {
      disabledDate(time) {
        return time.getTime() > Date.now() - 8.64e6;
      },
    },
    fileList: [], //文件列表
    uploading: false,
    addDialogVisible: false,
    addDetails: {},
    hostUrl: getBaseUrl(),
    imageUrl: "",
    loadings: {
      loading: false,
      editLoading: false,
      exportLoading: false,
    },
    searchDatas: {
      PageIndex: 0,
      PageSize: 100000,
      SearchKey: "",
    },
    showDialog: false,
    showNewDialog: false,
    tableDatas: [], // tableListData 展示数据的data
    foldList: [], // 该数组中的值 都会在列表中进行隐藏  死亡名单
    total: 0,
    downloadVisible: false, //下载弹窗的开关
    queryParams: {
      IsSet: false,
    },
    newModel: {
      Ptype: 10,
      IsValid: true,
    },
    tableHeight: window.innerHeight * 0.9, //表格的高
    fullHeight: document.documentElement.clientHeight, //获取屏幕高度
    tableDataNum: 0,
    filterValue: [], // PM过滤器的值
    directorFilterValue: [], // 负责人过滤器的值
    isShowTable: false,
  }),
  mounted() {
    // this.tableData.forEach((v) => {
    //     if (!Array.isArray(v.Memo9)) {
    //     // v.Memo9 = v.Memo9.join(",");
    //     v.Memo9 = v.Memo9.split(",");
    //     }
    //   })
    // console.log("tableData", this.tableData);
    
    this.initializationFilterValue();
  },

  methods: {
    forceUpdateChange(scope) {

      this.$set(scope.row, "Memo3", scope.row.Memo3);
    },
    delDetailsClick(scope) {
      this.tableData.splice(scope.$index, 1);
    },
    addDetailsClick(scope) {
      this.tableDataNum = scope.$index;
      this.addDetails = JSON.parse(JSON.stringify(scope.row));
      for (let i = 1; i < 16; i++) {
        this.$set(this.addDetails, `Memo${i}`, "");
      }
      this.addDetails.Memo41 = 1;
      this.addDetails.trueFalse = 1;
      this.tableData.splice(this.tableDataNum + 1, 0, this.addDetails);
    },
    shouldShowButton(memo9) {
      // 检查 memo9 是否是数组且有内容
      if (Array.isArray(memo9) && memo9.length > 0) {
        return true;
      }
      // 检查 memo9 是否是字符串且有内容（非空白）
      if (typeof memo9 === "string" && memo9.trim().length > 0) {
        return true;
      }
      // 如果都不是，返回 false
      return false;
    },
    openW(item) {
      // console.log(item.Memo9.split(',').filter(element => element.trim() !== '').length);

      if (!Array.isArray(item.Memo9)) {
        // 如果 Memo9 不是数组，那么我们可以处理它（例如，分割成数组）
        item.Memo9 = item.Memo9.split(",").filter(
          (subItem) => subItem.trim() !== ""
        );
      }

      if (item.Memo9.length > 1) {
        item.downloadVisibss = !item.downloadVisibss;
      } else {
        item.downloadVisibss = false;

        window.open(this.hostUrl + "/api/File/DownLoad/" + item.Memo9[0]);
      }

      // console.log("item", item,999);
      // if(item.Memo9.slice(-1)===','){
      // item.Memo9 = item.Memo9.substring(0, item.Memo9.length - 1);
      // }
      // item.Memo9.split(",").forEach((v,index) => {
      // console.log("v", v);
      // window.open(this.hostUrl + "/api/File/DownLoad/" + item);
      // setTimeout(() => {
      // console.log(v);

      // window.open(this.hostUrl + "/api/File/DownLoad/" + v);
      // },index*1000); // 延迟 index * 1000 毫秒
      // });
      // window.open(this.hostUrl + "/api/File/DownLoad/" + item.Memo9);
    },//下载时
    // afterEnter(item){},//
    materialdelete(item) {
      if (!Array.isArray(item.Memo9)) {
        // 如果 Memo9 不是数组，那么我们可以处理它（例如，分割成数组）
        item.Memo9 = item.Memo9.split(",").filter(
          (subItem) => subItem.trim() !== ""
        );
      }
      if (item.Memo9.length > 1) {
        item.downloadVisibss = !item.downloadVisibss;
      } else {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // if (item.Memo9.length>1) {
          //   item.downloadVisibss=!item.downloadVisibss

          // }else{
          //   // item.Memo9=item.Memo9.filter(element => element !==item.Memo9)
          item.Memo9 = [];
          //   // if (Array.isArray(item.Memo9)) {
          //   // item.Memo9=item.Memo9.join(',')
          //   // }
          //   console.log("item", item.Memo9,88877);

          // }
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消删除",
        //   });
        // });
      }
    },
    openWPlural(item) {
      window.open(this.hostUrl + "/api/File/DownLoad/" + item);
    }, //当多个文件时分开下载
    openWdelete(row, item) {
      if (!Array.isArray(row.Memo9)) {
        row.Memo9 = row.Memo9.split(",").filter(
          (subItem) => subItem.trim() !== ""
        );
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.Memo9 = row.Memo9.filter((element) => element !== item);
          if (row.Memo9.length == 1) {
            row.downloadVisibss = false;
          }
          // if (Array.isArray(row.Memo9)) {
          //   row.Memo9=row.Memo9.join(',')
          // }
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }, //删除文件
    importProgress(files) {
      this.uploading = true;
    },
    beforeUpload(files) {

      return true;
    },
    importError(files) {
      this.uploading = false;
    },
    importSuccess(response, scope) {
      if (response.Code == -1) {
        this.$message.error(response.Msg);
      } else {
        if (Array.isArray(scope.row.Memo9)) {
          // 如果是数组，将其转换为以逗号分隔的字符串
          // 注意：这里假设数组中的元素已经是字符串，且不需要额外的处理
          scope.row.Memo9 = scope.row.Memo9.join(",");
        }
        if (!scope.row.Memo9.endsWith(",")) {
          // 如果Memo9不以逗号结尾，添加一个逗号和新值
          scope.row.Memo9 += "," + response.Data[0];
        } else {
          // 如果Memo9已经以逗号结尾，直接添加新值（这里其实不需要再检查，因为上面的条件已经确保了这一点，但为了清晰起见还是写出来）
          scope.row.Memo9 += response.Data[0];
        }
        scope.row.Memo9=scope.row.Memo9.split(",").filter(item => item.trim() !== '')

        // scope.row.Memo9 += response.Data[0]+',';
        // console.log(scope.row.Memo9);
      }

      this.uploading = false;
    },
    arrangementM(arr, data, num) {
      let input = document.getElementsByTagName("input");
      data.forEach((v) => {
        if (v.ItemTypeCode != "label") {
          if (num == 0) {
            arr.push({
              Id: v.Id ? v.Id : 0,
              UUID: v.UUID ? v.UUID : uuidv4(),
              CallReportId: v.CallReportId ? v.CallReportId : 0,
              TemplateItemId: v.TemplateItemId,
              Memo1: v.Memo1 ? v.Memo1 : "",
              Memo2: v.Memo2 ? v.Memo2 : "",
              Memo3: v.Memo3 ? v.Memo3 : "",
              Memo4: v.Memo4 ? v.Memo4 : "",
              Memo5: v.Memo5 ? v.Memo5 : "",
              Memo6: v.Memo6 ? v.Memo6 : "",
              Memo7: v.Memo7 ? v.Memo7 : "",
              Memo8: v.Memo8 ? v.Memo8 : "",
              Memo9: v.Memo9 ? v.Memo9 : "",
              Memo10: v.Memo10 ? v.Memo10 : "",
              Memo11: v.Memo11 ? v.Memo11 : "",
              Memo41: v.Memo41 ? v.Memo41 + "" : "",
              ItemLabel: v.ItemLabel,
              Memo1Type: v.Memo1Type ? v.Memo1Type : "",
            });
          } else if (
            v.Memo1 &&
            v.Memo1.indexOf("NA") == -1 &&
            v.Memo1 != "未查" &&
            v.Memo1 != "未发现问题" &&
            v.Memo1 != "优"
          ) {
            if (num == 1) {
              arr.push({
                Memo6: v.Memo6 ? v.Memo6 : "",
                ServerId: v.Id ? v.Id : 0,
                CallReportId: 0,
                ItemLabel: v.ItemLabel,
              });
            } else if (num == 2) {
              arr.push({
                Memo6: v.Memo6 ? v.Memo6 : "",
                Memo7: v.Memo7 ? v.Memo7 : "",
                Memo8: v.Memo8 ? v.Memo8 : "",
                Memo9: v.Memo9 ? v.Memo9 : "",
                Memo10: v.Memo10 ? v.Memo10 : "",
                Memo11: v.Memo11 ? v.Memo11 : "",
                ServerId: v.Id ? v.Id : 0,
                CallReportId: 0,
                ItemLabel: v.ItemLabel,
              });
            } else if (num == 3) {
              arr.push({
                Memo12: v.Memo12 ? v.Memo12 : "",
                Memo13: v.Memo13 ? v.Memo13 : "",
                ServerId: v.Id ? v.Id : 0,
                CallReportId: 0,
                ItemLabel: v.ItemLabel,
              });
            } else if (num == 4) {
              arr.push({
                Memo14: v.Memo14 ? v.Memo14 : "",
                Memo15: v.Memo15 ? v.Memo15 : "",
                ServerId: v.Id ? v.Id : 0,
                CallReportId: 0,
                ItemLabel: v.ItemLabel,
              });
            }
          }
        }
      });
      return arr;
    },
    callMethod() {
      // if (sessionStorage.getItem("stateName") == "待PM反馈") {
      //   let arr = this.arrangementM([], this.tableData, 1);
      //   for (let i = 0; i < arr.length; i++) {
      //     if (!arr[i].Memo6) return [1];
      //   }
      //   return arr;
      // } else
      if (sessionStorage.getItem("stateName") == "待CRC整改") {
        console.log("待CRC整改");
        let arr = this.arrangementM([], this.tableData, 2);
        if (sessionStorage.getItem("storageCRC") == 2) {
          for (let i = 0; i < arr.length; i++) {
            if (
              !arr[i].Memo11 ||
              !arr[i].Memo8 ||
              !arr[i].Memo7 ||
              !arr[i].Memo6
            )
              return [1, arr[i].ItemLabel];
          }
        }
        return arr;
      } else if (sessionStorage.getItem("stateName") == "待PM审核") {
        console.log("待PM审核");
        let arr = this.arrangementM([], this.tableData, 3);
        if (sessionStorage.getItem("storageCRC") == 2) {
          for (let i = 0; i < arr.length; i++) {
            if (!arr[i].Memo12) return [1, arr[i].ItemLabel];
            if (arr[i].Memo12 == "2" && !arr[i].Memo13)
              return [2, arr[i].ItemLabel];
          }
        }
        return arr;
      } else if (sessionStorage.getItem("stateName") == "待负责人审核") {
        console.log("待负责人审核");
        let arr = this.arrangementM([], this.tableData, 4);
        if (sessionStorage.getItem("storageCRC") == 2) {
          for (let i = 0; i < arr.length; i++) {
            if (!arr[i].Memo14) return [1, arr[i].ItemLabel];
            if (arr[i].Memo14 == "2" && !arr[i].Memo15)
              return [2, arr[i].ItemLabel];
          }
        }
        return arr;
      } else {
        //前五
        let arr = this.arrangementM([], this.tableData, 0);
        if (sessionStorage.getItem("stateName") != "草稿") {
          for (let i = 0; i < arr.length; i++) {
            const v = arr[i];
            if (
              v.ItemLabel.indexOf("其他") != -1 &&
              !v.Memo1Type &&
              !v.Memo1 &&
              v.Memo3 &&
              v.Memo3 != "NA"
            ) {
              return [3, v.ItemLabel];
            }
            if ((!v.Memo1 || v.Memo1 == null) && v.Memo1Type) {
              return [0, v.ItemLabel];
            }
            if (
              (v.Memo1 == "其他，请说明：" || v.Memo1 == "其他，请描述：") &&
              v.Memo2 == ""
            ) {
              return [1, v.ItemLabel];
            }
            if (
              v.Memo1 &&
              v.Memo1.indexOf("NA") == -1 &&
              v.Memo1 != "未查" &&
              v.Memo1 != "未发现问题" &&
              v.Memo3 == "" &&
              v.Memo1 != "优"
            ) {
              return [2, v.ItemLabel];
            }
          }
        }
        return arr;
      }
    },
    lookSons(array, data, a = 2) {
      array.forEach((it, i) => {
        data.forEach((item) => {
          if (it.UUID == item.ParentId) {
            item.Levels = a;
            it.Children.push(item);
          }
        });
        if (it.Children && it.Children.length > 0) {
          a++;
          this.lookSons(it.Children, data, a);
        }
        a = 2;
      });
      return array;
    },
    Memo1Chenge(row) {
      if (
        row.Memo1.indexOf("NA") != -1 ||
        row.Memo1 == "未查" ||
        row.Memo1 == "未发现问题" ||
        row.Memo1 == "优"
      ) {
        for (let i = 2; i < 16; i++) {
          row[`Memo${i}`] = "";
        }
      }
    },
    toggleFoldingStatus(params) {
      this.foldList.includes(params.Identity)
        ? this.foldList.splice(this.foldList.indexOf(params.Identity), 1)
        : this.foldList.push(params.Identity);
    },
    toggleDisplayTr({ row, index }) {
      if (this.foldList) {
        for (let i = 0; i < this.foldList.length; i++) {
          let item = this.foldList[i];
          // 如果foldList中元素存在于 row.Family中，则该行隐藏。  如果该行的自身标识等于隐藏元素，则代表该元素就是折叠点
          if (row.Family.includes(item) && row.Identity !== item) {
            return "display:none;";
          }
        }
      }
      return "";
    },
    toggleFoldingClass(params) {
      if (params.Children) {
        return params.Children.length === 0
          ? "el-icon-folder"
          : this.foldList.indexOf(params.Identity) === -1
          ? "el-icon-folder-remove"
          : "el-icon-folder-add";
      } else {
        return "el-icon-folder";
      }
    },
    filterHandler(value, row, column) {
      // console.log(value, row, column,)
      this.filterValue = [value];
      switch (value) {
        case "1":
          return row["Memo12"] === value;
          break;
        case "2":
          return row["Memo12"] === value;
          break;
        case "0":
          return (
            (row.Memo1.indexOf("NA") != -1 ||
              row.Memo1 == "未查" ||
              row.Memo1 == "未发现问题" ||
              row.Memo1 == "优" ||
              !row.Memo12True) === false && !["1", "2"].includes(row["Memo12"])
          );
          break;
      }
    },
    directorFilterHandler(value, row, column) {
      // console.log(value, row, column,)
      this.directorFilterValue = [value];

      switch (value) {
        case "1":
          return row["Memo14"] === value;
          break;
        case "2":
          return row["Memo14"] === value;
          break;
        case "0":
          return (
            (row.Memo1.indexOf("NA") != -1 ||
              row.Memo1 == "未查" ||
              row.Memo1 == "未发现问题" ||
              row.Memo1 == "优" ||
              !row.Memo14True) === false && !["1", "2"].includes(row["Memo14"])
          );
          break;
      }
    },
    initializationFilterValue() {
      let setTimeOut = null;
      const check = () => {
        if (this.tableData.length === 0) {
          setTimeOut = setTimeout(check, 10);
        } else {
          // PM过滤器初始化
          // 根据是否有可编辑的行，来决定是否默认筛选拒绝状态
          const isEdit = this.tableData.some((item) => {
            return (
              (item.Memo1.indexOf("NA") != -1 ||
                item.Memo1 == "未查" ||
                item.Memo1 == "未发现问题" ||
                item.Memo1 == "优" ||
                !item.Memo12True) === false
            );
          });
          // isDefaultRefuse 批准/拒绝按钮存在 为true
          if (this.isDefaultRefuse && isEdit) {
            this.filterValue = ["2", "0"]; // PM初始化过滤器拒绝状态
          }

          // 负责人过滤器初始化
          if (!isEdit) {
            const directorIsEdit = this.tableData.some((item) => {
              return (
                (item.Memo1.indexOf("NA") != -1 ||
                  item.Memo1 == "未查" ||
                  item.Memo1 == "未发现问题" ||
                  item.Memo1 == "优" ||
                  !item.Memo14True) === false
              );
            });
            // isDefaultRefuse 批准/拒绝按钮存在 为true
            if (this.isDefaultRefuse && directorIsEdit) {
              this.directorFilterValue = ["2", "0"]; // 负责人初始化过滤器拒绝状态
            }
          }

          this.isShowTable = true; // 显示表格,触发默认筛选
          clearTimeout(setTimeOut);
        }
      };
      // 初始化定时器
      setTimeOut = setTimeout(check, 10); // 等待 tableData 数据加载
    },
    // 自动聚焦
    setFocus(label, number) {
      console.log('lable', label);
      if(number === '审核') {
        this.tableData.forEach((item, index) => {
          if(item.ItemLabel == label) {
            if(!item.Memo6) {
              this.$refs[`tableColumn${index}4`].focus()
            } else if(!item.Memo11) {
              this.$refs[`tableColumn${index}5`].focus()
            } else if(!item.Memo7) {
              this.$refs[`tableColumn${index}6`].focus()
            } else if(!item.Memo8) {
              this.$refs[`tableColumn${index}7`].focus()
            }
          }
        })
        return;
      }
      // 填写
      this.tableData.forEach((item, index) => {
        if(item.ItemLabel == label) {
          this.$refs[`tableColumn${index}${number}`].focus()
        }
      })
    },
  },
};
</script>

<style scoped lang="less">
.site-info-view-title {
  padding: 5px 20px;
  line-height: 60px;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#listPage {
  overflow-y: auto;
}
// textarea {
//   height: 100%;
// }
[con-filter] {
  padding-top: 10px;
  padding-left: 20px;
  padding-bottom: 10px;
  background-color: rgba(235, 235, 235, 0.3);
  /* border-bottom: 1px solid #ccccee; */
}

[all-buttons] {
  padding-top: 10px;
  padding-left: 20px;
  padding-bottom: 10px;
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  background-color: rgba(235, 235, 235, 0.6);
  border-top: 1px solid #eee;
}

[content-body] {
  width: 100%;
  margin-top: 10px;
}

.el-button-group {
  margin-left: 10px;
}

.el-button-group .el-button {
  padding: 7px 10px;
}

[import-dialog] {
  padding: 10px 30px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 193px;
}

[tree-icon-collapse] {
  cursor: pointer;
}

[title-btn] {
  position: absolute;
  top: 81px;
  right: 15px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.filter-tree {
  width: 700px;
}

// .el-tree >>> .el-tree-node__content {
//   height: 30px !important;
// }

[el-card-task] {
  padding: 5px;
  margin-bottom: 20px;
  cursor: pointer;
}

// [el-card-task] >>> .el-card__body {
//   padding: 0px;
// }

[el-card-task-img] {
  width: 100%;
  height: 12vw;
  object-fit: cover;
}

[el-card-task-desc] {
  padding: 10px;
  height: 25px;
  line-height: 25px;
}

[el-card-task-title] {
  float: left;
  color: darkgrey;
}

[el-card-task-btn] {
  float: right;
  padding: 5px;
}

// .el-form-item >>> .el-form-item__content {
//   min-width: 193px;
// }

/* .tree-table-css >>> .el-table__body  tr:hover>td {
    background-color: #fff;
} */

.promote-form-ele-wrap .el-select {
  width: 50%;
}
.dialog {
  min-width: 900px !important;
}
.el-date-editor.el-input {
  width: 100%;
}
.dates {
  /deep/ .el-input {
    width: 100% !important;
  }
  /deep/ .el-input__inner {
    padding: 0 5px;
  }
  /deep/ .el-input__prefix {
    display: none;
  }
}
.tables {
  /deep/ th {
    background-color: rgba(221, 221, 221, 0.5) !important;
  }
  /deep/ thead {
    color: #000;
  }
  /deep/ .el-textarea__inner {
    padding: 0;
  }
  /deep/ .el-table__body-wrapper {
    min-height: 100px !important;
  }
}
.el-radio {
  margin-right: 15px;
}
.el-radio__label {
  margin-left: 5px;
}
.isdisabled {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
}
.upload_comps {
  margin: 0px 0px 10px 0px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/centeruser/ProjectInfo.vue